import { Stack } from "@mui/material";
import StatusChip from "@entrilia/shared/components/StatusChip";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import type { WorkbookRunStatus } from "../../../../../api/types/workbookRuns.types";
import { getStatusColor, getStatusLabel } from "../workbookRunUtils";

interface Props {
  name: string;
  status: WorkbookRunStatus | undefined;
}

const WorkbookRunDetailsPageTitle = ({ name, status }: Props) => {
  return (
    <Stack spacing={0.5} sx={{ py: 1.5, maxWidth: "700px" }}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <TypographyTooltipEllipsis typographyProps={{ variant: "h6" }} text={name} />
        {status && <StatusChip label={getStatusLabel(status)} withDot color={getStatusColor(status)} />}
      </Stack>
    </Stack>
  );
};

export default WorkbookRunDetailsPageTitle;
